import styled from 'styled-components';
import media from 'styled-media-query';

export const Container = styled.div`
  margin: 40px 0 60px;
  display: inline-block;
`;

export const Title = styled.div`
  position: relative;
  display: inline-block;
`;

export const TitleElement = styled.h1`
  line-height: 140%;
  font-size: 2.2rem;
  font-family: var(--font-anton);
  color: var(--text-light);
  clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  transition: all 1.5s;
  transform: translateY(-1.5em);
  ${media.greaterThan('medium')`
    line-height: 1.1;
    font-size: 3.5rem;
  `}

  ${media.greaterThan('large')`
    line-height: 1.1;
    font-size: 4rem;
  `}
`;

export const Description = styled.h2`
  line-height: 2rem;
  font-size: 1.3rem;
  font-family: var(--font-open);
  font-weight: bold;
  color: var(--thirdy-color);
  max-width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  transition: all 1.5s;
  transform: translateY(-1.5em);
  ${media.greaterThan('medium')`
    margin-top: 10px;
    font-size: 1.5rem;
    line-height: 2.5rem;
  `}

  ${media.greaterThan('large')`
    font-size: 2rem;
    line-height: 3rem;
  `}
`;

export const ImageContainer = styled.div`
  position: absolute;
  top: -20px;
  right: -40px;
  z-index: -1;
  svg {
    opacity: 0;
  }
`;
